import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { combineLatest } from 'rxjs';
import { filter, first, map, startWith, switchMap, takeUntil } from 'rxjs/operators';

import { BaseCtrlValueAccessorFormComponent } from '@sim/form';

import { PRV } from '@atmi/core/models';

@Component({
  selector: 'app-prv-form',
  styleUrls: ['./prv-form.component.scss'],
  templateUrl: './prv-form.component.html',
})
export class PrvFormComponent extends BaseCtrlValueAccessorFormComponent<PRV> implements OnDestroy, OnInit {

  constructor() {
    super();

    this.formChange.pipe(
      first((form): form is UntypedFormGroup => !!form),
      switchMap((form) => combineLatest([
        this.formChange,
        form.valueChanges.pipe(startWith(undefined)),
      ]).pipe(
        map(([f]) => f),
        filter((f): f is UntypedFormGroup => !!f),
        takeUntil(this.unsubscription$),
      )),
      filter((form): form is UntypedFormGroup => !!form),
      takeUntil(this.unsubscription$),
    ).subscribe((form) => {
      if (form.controls.PRVS.value === undefined) {
        form.controls.PRVR.disable({ emitEvent: false });
      } else {
        form.controls.PRVR.enable({ emitEvent: false });
      }

      if (form.controls.PRVR.value === undefined) {
        form.controls.PRVP.disable({ emitEvent: false });
      } else {
        form.controls.PRVP.enable({ emitEvent: false });
      }

      if (form.controls.PRVP.value === undefined) {
        form.controls.PRVC.disable({ emitEvent: false });
      } else {
        form.controls.PRVC.enable({ emitEvent: false });
      }
    });
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
